export class tItemModel {

    shopID: string;
    itemID: string;
    itemBarcode: string;
    itemSeq: number;
    itemDesc: string;
    itemDescEng: string;
    itemDescMobile: string;
    itemCateID: string;

    itemUnit: number;
    itemSysCost: number;
    itemCost: number;

    standardPrice: number;
    itemNeedTime: number;
    itemRemark1: string;
    itemRemark2: string;
    itemRemark3: string;

    inActive: string;
    isServiceDefault:string;
    isNegativeQty:string;
    lastModifyDatetime: Date;
    lastModifyUserID: string;
}


export class tItemModelwithCateInfo extends tItemModel {

    itemCateName: string;
}




export class preDefineItemCode {
    static cupping = '9903';
 }
